<template>
  <div class="wall">
    <div class="wall-head flex-items-center">
      部门角色
      <el-button class="ml-auto" type="primary" size="small" round @click="handleCreate()">
        新增角色
      </el-button>
    </div>
    <div class="mt-35 p-30 container" v-loading="bodyLoding">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="address" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="success" size="mini" plain>编辑</el-button>
            <el-popconfirm
              title="确认删除当前角色？"
              @onConfirm="handleRemove(scope.row)"
              class="ml-10"
            >
              <el-button slot="reference" type="text" size="small">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 弹窗 -->
    <el-dialog
      title="角色权限"
      :visible.sync="dialogVisible"
      width="650px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose">
      <rs-form ref="form" :model="formData" :errors="formErrors" :rules="rules" label-width="90px">
        <el-form-item label="名称：" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="权限：">
          <el-checkbox-group v-model="formData.permissions">
            <div v-for="(topItem, topInd) in permissions" :key="topInd">
              <div class="fs-16">
                <strong>{{ topItem.label }}</strong>
              </div>
              <div>
                <el-checkbox
                  v-for="(subItem, subInd) in topItem.items"
                  :key="subInd"
                  :label="subItem.id"
                >
                  {{ subItem.label }}
                </el-checkbox>
              </div>
            </div>
          </el-checkbox-group>
        </el-form-item>
      </rs-form>
      <span slot="footer" class="dialog-footer">
        <el-button plain round class="main-btn" @click="handleClose">
          取 消
        </el-button>
        <el-button round class="main-btn ml-20" type="primary" @click="handleSubmit" :loading="dialogSubmitLoading">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getRolesList, deleteRole, updateRole, createRole } from '@/api/role'
import permissions from '@/utils/permissions'

export default {
  data() {
    return {
      bodyLoding: false,
      dialogLoading: false,
      dialogSubmitLoading: false,
      dialogVisible: false,
      tableData: [],
      formData: {
        name: null,
        permissions: []
      },
      formErrors: {},
      permissions,
      rules: {
        name: [
          { required: true, message: '角色不能为空', trigger: 'blur' },
          { min: 2, max: 30, message: '角色长度在 2 到 16 个字符之间', trigger: 'blur' }
        ]
      },
    }
  },
  created() {
    this.loadRolesList();
  },
  methods: {
    // 加载列表
    loadRolesList() {
      this.bodyLoding = true
      getRolesList().then(res => {
        this.bodyLoding = false
        this.tableData = res.results || []
      })
    },
    // 提交信息
    handleSubmit() {
      this.$refs['form'].validate((valid) => {
        if (!valid) return false;

        this.dialogSubmitLoading = true;
        this.saveData().then(() => {
          this.loadRolesList();
          this.dialogVisible = false;
          this.dialogSubmitLoading = false;
        }).catch(err => {
          this.formErrors = err.data || {};
          this.dialogSubmitLoading = false;
        })
      })
    },
    saveData() {
      return this.formData.id 
        ? updateRole(this.formData.id, this.formData)
        : createRole(this.formData)
    },
    // 移除
    handleRemove(row) {
      deleteRole(row.id).then(() => {
        this.loadRolesList()
      })
    },
    handleEdit(row) {
      this.formData = row
      this.dialogVisible = true;
    },
    // 显示弹窗
    handleCreate() {
      this.formData = {
        name: null,
        permissions: []
      }
      this.dialogVisible = true;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.formData =  {
        name: null,
        permissions: []
      };
      this.$nextTick(() => {
        this.$refs['form'].resetFields();
      });
    }
  }
}
</script>

<style scoped>
</style>
